<template>
  <section
    ref="section8"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="5"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >

      <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
        <v-error-display :validation-errors="validationErrors"></v-error-display>
        <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
          <div><v-icon icon="size" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mr-6 text-heading-3-desktop">
              Velikost nepremičnine
            </div>
          </div>

          <v-lightbox is-authenticated footerless>
            <template v-slot:trigger>
                <div
                    class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                >
                    <v-icon icon="question-mark" size="4"></v-icon>
                </div>
            </template>
            <template v-slot:head>
                <div class="flex items-start">
                    <v-icon
                        icon="question-mark"
                        class="mr-2.5"
                        size="4.5"
                    ></v-icon>
                    <div>
                        Dodatne informacije
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <p class="mb-[10px] text-icon-text-medium">
                    Površina
                </p>

                <template v-if="this.stepData.objektart == 'grundstueck'">
                  <p class="mb-8 text-body-regular">
                      Pri površini parcele vnesite velikost zemljišča, ki pripada nepremičnini.  Velikosti naj bodo podane v kvadtranih metrih (m²).
                  </p>
                </template>

                <template v-else>
                  <p class="mb-8 text-body-regular">
                      Pri bivalni površini nepremičnine vnesite neto površino, ki je namenjena bivanju. Pri površini parcele vnesite velikost zemljišča, ki pripada nepremičnini. V primeru, da nepremičnini ne pripada zemljišče vnesite številko 0. Velikosti naj bodo podane v kvadtranih metrih (m²). Oba polji sta obvezni.
                  </p>

                  <p class="mb-[10px] text-icon-text-medium">
                      Število sob, spalnic, kopalnic in nadstropij
                  </p>
                  <p class="mb-4 text-body-regular">
                      Število sob - v tem polju vnesite koliko sobno je stanovanje (1-sobno, 2-sobno, 3-sobno, itd.). Vnesite zgolj številko.
                  </p>
                  <p class="mb-4 text-body-regular">
                      Število spalnic - v tem polju vnesite število sob, ki so namenjene za spalnice.
                  </p>
                  <p class="mb-4 text-body-regular">
                      Število kopalnic - v tem polju vnesite število kopalnic in toalet nepremičnine.
                  </p>
                  <p class="mb-4 text-body-regular">
                      Število nadstropij - vnesite število nadstopij vaše nepremičnine.
                  </p>
                </template>
            </template>
          </v-lightbox>
        </figure>
        <figure class="ml-auto mr-auto w-full max-w-lg">
          <form method="POST" :action="routes.submitForm" id="select-size">
            <v-csrf-token></v-csrf-token>
            <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-8">
              <li class="col-span-4" v-if="['haus', 'zimmer', 'wohnung', 'ind_Schl_3259', 'hausbau'].includes(this.stepData.objektart)">
                <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.wohnflaeche ? 'has-errors' : '')]">
                  <label
                    for="bivalnaPovrsina"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="square-size" size="4"></v-icon>
                        <span>
                          Bivalna površina
                          <sup>*</sup></span
                        >
                      </div>
                    </div>
                  </label>
                  <input
                    id="bivalnaPovrsina"
                    type="number"
                    name="wohnflaeche"
                    placeholder="Bivalna površna"
                    v-model="livingArea"
                  />
                  <div
                    class="absolute bottom-[18px] right-6 text-body-medium-button "
                    :class="livingArea ? 'text-black-78' : 'text-black-40'"
                    >m<sup>2</sup></div
                  >
                </div>
              </li>
              <li class="col-span-4" v-if="['haus', 'hausbau', 'grundstueck'].includes(this.stepData.objektart)">
                <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.grundstuecksflaeche ? 'has-errors' : '')]">
                  <label
                    for="povrsinaParcele"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="land" size="4"></v-icon>
                        <span>
                          Površina parcele
                          <sup>*</sup></span
                        >
                      </div>
                    </div>
                  </label>
                  <input
                    id="povrsinaParcele"
                    type="number"
                    name="grundstuecksflaeche"
                    placeholder="Površina parcele"
                    v-model="landArea"
                  />
                  <div
                    class="absolute bottom-[18px] right-6 text-body-medium-button "
                    :class="landArea ? 'text-black-78' : 'text-black-40'"
                    >m<sup>2</sup></div
                  >
                </div>
              </li>
              <li class="col-span-2" v-if="['haus', 'wohnung', 'ind_Schl_3259', 'hausbau'].includes(this.stepData.objektart)">
                <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.anzahl_zimmer ? 'has-errors' : '')]">
                  <label for="steviloSob" class="w-full text-body-medium-button">
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="dor" size="4"></v-icon>
                        <span>
                          Število sob
                          <sup>*</sup></span
                        >
                      </div>
                    </div>
                  </label>
                  <input
                    id="steviloSob"
                    type="number"
                    name="anzahl_zimmer"
                    placeholder="Število"
                    v-model="numberOfRooms"
                  />
                </div>
              </li>
              <li class="col-span-2" v-if="['haus', 'wohnung', 'ind_Schl_3259', 'hausbau'].includes(this.stepData.objektart)">
                <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.anzahl_schlafzimmer ? 'has-errors' : '')]">
                  <label
                    for="steviloSpalnic"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="bed" size="4"></v-icon>
                        <span>
                          Število spalnic
                          <sup>*</sup></span
                        >
                      </div>
                    </div>
                  </label>
                  <input
                    id="steviloSpalnic"
                    type="number"
                    name="anzahl_schlafzimmer"
                    placeholder="Število"
                    v-model="numberOfBedrooms"
                  />
                </div>
              </li>
              <li class="col-span-2" v-if="['haus', 'wohnung', 'ind_Schl_3259', 'hausbau'].includes(this.stepData.objektart)">
                <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.anzahl_badezimmer ? 'has-errors' : '')]">
                  <label
                    for="steviloKopalnic"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="shower"></v-icon>
                        <span>
                          Število kopalnic
                          <sup>*</sup></span
                        >
                      </div>
                    </div>
                  </label>
                  <input
                    id="steviloKopalnic"
                    type="number"
                    name="anzahl_badezimmer"
                    placeholder="Število"
                    v-model="numberOfBathrooms"
                  />
                </div>
              </li>
              <li class="col-span-2" v-if="['haus', 'hausbau'].includes(this.stepData.objektart)">
                <div :class="['input group relative flex flex-col gap-[10px]', (validationErrors.etagen_zahl ? 'has-errors' : '')]">
                  <label
                    for="steviloNadstropij"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="floor"></v-icon>
                        <span>
                          Število nadstropij
                          <sup>*</sup></span
                        >
                      </div>
                    </div>
                  </label>
                  <input
                    id="steviloNadstropij"
                    type="number"
                    name="etagen_zahl"
                    placeholder="Število"
                    v-model="numberOfFloors"
                  />
                </div>
              </li>
            </ul>
            <div class="relative py-10" v-if="showFloor">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-200"></div>
                </div>
            </div>
            <figure class="flex gap-3 w-full max-w-lg mx-auto" v-if="showFloor">
            <div><v-icon icon="stairs" size="8"></v-icon></div>
            <div class="flex flex-col justify-center">
                <div class="text-heading-3-desktop">
                V katerem nadstropju je vaša nepremičnina?
                <!-- V katerem nadstropju je vaša soba? -->
                </div>
            </div>
            </figure>
            <figure class="w-full max-w-lg mx-auto" v-if="showFloor">
            <v-floor-selection
                ref="floorPicker"
                :default-floor="this.stepData.etage ?? 1"
                :routes="routes"
                :validation-errors="validationErrors"
            ></v-floor-selection>
            </figure>
            <div class="relative py-10">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-200"></div>
                </div>
            </div>
            <figure class="flex gap-3 max-w-lg mx-auto">
                <div><v-icon icon="tag" size="8"></v-icon></div>
                <div class="flex flex-col justify-center">
                    <div class="text-heading-3-desktop">
                        Po kakšni ceni prodajate nepremičnino?
                    </div>
                </div>
            </figure>
            <figure
                class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8 mt-11"
                v-if="stepData.vermarktungsart == 'kauf'"
            >
                <ul class="flex flex-col gap-8">
                    <li class="w-full">
                        <div
                            :class="[
                                'input group relative relative flex flex-col gap-[10px]',
                                validationErrors.preis
                                    ? 'has-errors'
                                    : '',
                            ]"
                        >
                            <label
                                for="addPrice"
                                class="w-full text-body-medium-button"
                            >
                                <div
                                    class="label flex flex-col gap-[10px]"
                                >
                                    <div
                                        class="flex items-center gap-3"
                                    >
                                        <v-icon
                                            icon="euro"
                                            size="4"
                                        ></v-icon>
                                        <span>
                                            Ponudbena cena
                                            <sup>*</sup></span
                                        >
                                    </div>
                                </div>
                            </label>
                            <input
                                id="addPrice"
                                type="text"
                                name="preis"
                                placeholder="Ponudbena cena"
                                v-model="price"
                            />
                            <span
                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                :class="price ? 'text-black-78' : 'text-black-40'"
                                >€</span
                            >
                        </div>
                    </li>
                    <li class="w-full">
                        <v-checkbox
                            label="Brez provizije"
                            checkbox-position="right"
                            name="brezProvizije"
                            :checked="Boolean(provisionCasted)"
                            icon="add-card"
                            @vchanged="provision = !provision"
                        ></v-checkbox>
                    </li>
                    <li v-show="!Boolean(provisionCasted)" class="w-full">
                        <div
                            :class="[
                                'textarea group flex items-center',
                                validationErrors.preis
                                    ? 'has-errors'
                                    : '',
                            ]"
                        >
                            <label
                                for="visinaProvizijeZaKupca"
                                class="flex w-full flex-col gap-[10px] text-body-medium-button"
                            >
                                <div class="label flex flex-col gap-10">
                                    <div class="flex items-start gap-3">
                                        <v-icon icon="percent"></v-icon>
                                        <div
                                            class="flex flex-col gap-[10px]"
                                        >
                                            <div>
                                                Višina provizije za
                                                kupca
                                            </div>
                                            <small
                                                class="text-body-regular text-black-40"
                                                >Opišite podrobno višino
                                                provizije v %, z ali
                                                brez DDV-ja in pogoje
                                                plačila
                                                provizije.</small
                                            >
                                        </div>
                                    </div>
                                </div>
                                <textarea
                                    id="visinaProvizijeZaKupca"
                                    name="aussen_courtage"
                                    placeholder="Višina provizije za kupca"
                                    rows="10"
                                    class="pl-7"
                                    v-model="provisionAmount"
                                ></textarea>
                                <small
                                    class="flex w-full justify-end text-small-text-regular text-black-40"
                                    >0/80 besed</small
                                >
                            </label>
                        </div>
                    </li>
                </ul>
                <input
                    type="text"
                    name="provisionsfrei"
                    class="hidden"
                    v-model="provisionCasted"
                />
            </figure>

            <figure
                class="ml-auto mr-auto max-w-lg w-full mt-11"
                v-if="stepData.vermarktungsart == 'miete'"
            >
                <ul
                    class="grid grid-cols-4 flex-col gap-x-5 gap-y-8"
                >
                    <li class="col-span-4">
                        <div
                            :class="[
                                'input group relative flex flex-col gap-[10px]',
                                validationErrors.kaltmiete
                                    ? 'has-errors'
                                    : '',
                            ]"
                        >
                            <label
                                for="netoNajemnina"
                                class="w-full text-body-medium-button"
                            >
                                <div
                                    class="label flex flex-col gap-[10px]"
                                >
                                    <div
                                        class="flex items-center gap-3"
                                    >
                                        <v-icon
                                            icon="payments"
                                            size="4"
                                        ></v-icon>
                                        <span>
                                            <span v-text="stepData.kaltmieteLabel"></span>
                                            <sup>*</sup>
                                        </span>
                                    </div>
                                </div>
                            </label>
                            <input
                                id="netoNajemnina"
                                type="number"
                                name="kaltmiete"
                                :placeholder="stepData.kaltmieteLabel"
                                v-model="
                                    kaltmiete
                                "
                            />
                            <div
                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                :class="kaltmiete ? 'text-black-78' : 'text-black-40'"
                                >€/mesec</div
                            >
                        </div>
                    </li>
                    <li class="col-span-4">
                        <div
                            :class="[
                                'input group relative flex flex-col gap-[10px]',
                                validationErrors.warmmiete
                                    ? 'has-errors'
                                    : '',
                            ]"
                        >
                            <label
                                for="netoNajemnina"
                                class="w-full text-body-medium-button"
                            >
                                <div
                                    class="label flex flex-col gap-[10px]"
                                >
                                    <div
                                        class="flex items-center gap-3"
                                    >
                                        <v-icon
                                            icon="payments"
                                            size="4"
                                        ></v-icon>
                                        <span>
                                            <span v-text="stepData.warmmieteLabel"></span>
                                            <sup>*</sup></span
                                        >
                                    </div>
                                </div>
                            </label>
                            <input
                                id="brutoNajemnina"
                                type="number"
                                name="warmmiete"
                                :placeholder="stepData.warmmieteLabel"
                                v-model="warmmiete"
                            />
                            <div
                                class="absolute bottom-[18px] right-6 text-body-medium-button"
                                :class="warmmiete ? 'text-black-78' : 'text-black-40'"
                                >€/mesec</div
                            >
                        </div>
                    </li>
                </ul>
            </figure>
          </form>
        </figure>
      </figure>
    </main>
    <v-add-listing-foot>
        <a
            :href="routes.previousStep ? routes.previousStep : '/'"
            class="button button--white button--md h-[48px] w-[240px] px-6 mr-4"
        >
            <v-icon icon="arrow-right" class="rotate-180" size="4"></v-icon>
            <label class="text-small-text-medium">Nazaj</label>
        </a>
      <a
        @click="submitForm('select-size')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';
import FloorSelection from '../FloorSelection.vue';
import ErrorDisplay from '../ErrorDisplay.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
    "v-floor-selection": FloorSelection,
    "v-error-display": ErrorDisplay
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    // Number of floors is disabled based on Notion bug #334
    return {
      numberOfBathrooms: null,
      numberOfBedrooms: null,
      numberOfRooms: null,
      numberOfFloors: null,
      landArea: null,
      objectType: null,
      livingArea: null,
      floor: null,
      price: null,
      provision: false,
      provisionAmount: null,
      kaltmiete: null,
      warmmiete: null,
    };
  },
  mounted() {
    this.numberOfBathrooms = (this.old.anzahl_badezimmer ? this.old.anzahl_badezimmer : this.stepData.anzahl_badezimmer)
    this.numberOfBedrooms = (this.old.anzahl_schlafzimmer ? this.old.anzahl_schlafzimmer : this.stepData.anzahl_schlafzimmer)
    this.numberOfRooms= (this.old.anzahl_zimmer ? this.old.anzahl_zimmer : this.stepData.anzahl_zimmer)
    this.numberOfFloors = (this.old.etagen_zahl ? this.old.etagen_zahl : this.stepData.etagen_zahl)
    this.landArea = (this.old.grundstuecksflaeche ? this.old.grundstuecksflaeche : this.stepData.grundstuecksflaeche)
    this.objectType = (this.old.objektart ? this.old.objektart : this.stepData.objektart)
    this.livingArea = (this.old.wohnflaeche ? this.old.wohnflaeche : this.stepData.wohnflaeche)
    this.floor = (this.old.etage ? this.old.etage : this.stepData.etage)
    this.price =(this.old.preis ? this.old.preis : this.stepData.preis)
    this.provision =(this.old.provisionsfrei ? this.old.provisionsfrei : this.stepData.provisionsfrei)
    this.provisionAmount =(this.old.aussen_courtage ? this.old.aussen_courtage : this.stepData.aussen_courtage)
    this.kaltmiete =(this.old.kaltmiete ? this.old.kaltmiete : this.stepData.kaltmiete)
    this.warmmiete =(this.old.warmmiete ? this.old.warmmiete : this.stepData.warmmiete)
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
  computed: {
    provisionCasted() {
            return this.provision ? 1 : 0;
    },
    showFloor() {
        let validOptions = ["wohnung", "ind_Schl_3259", "zimmer"];
        return validOptions.includes(this.stepData.objektart);
    },
    validated() {
        if(this.stepData.objektart == 'haus' || this.stepData.objektart == "hausbau") {
          if(
            !this.numberOfBathrooms ||
            !this.numberOfBedrooms ||
            !this.numberOfRooms ||
            !this.numberOfFloors ||
            !this.landArea ||
            !this.livingArea
          ) return false
        }

        if(this.stepData.objektart == 'zimmer') {
          if(!this.livingArea) return false
        }

        if(this.stepData.objektart == 'wohnung' || this.stepData.objektart == "ind_Schl_3259") {
          if(
            !this.livingArea ||
            !this.numberOfRooms ||
            !this.numberOfBedrooms ||
            !this.numberOfBathrooms
          ) return false
        }

        if(this.stepData.objektart == 'grundstueck') {
          if(!this.landArea) return false
        }

        if(this.stepData.vermarktungsart == 'kauf') {
            if(!this.price) return false

            if(this.provisionCasted == 0 && !this.provisionAmount) return false

            return true;
        }

        if(this.stepData.vermarktungsart == 'miete') {
            if(!this.kaltmiete || !this.warmmiete) return false
        }

        return true;
    }
  },
};
</script>
